import React from "react";
import { Workflow } from "/app/src/models";

import Title from "./title";

/**
 * Controls component renders workflow controls.
 *
 * @param {Object} param0 - The props object.
 * @param {Workflow} param0.workflow - The workflow data.
 * @returns {JSX.Element} The controls component.
 */
export default function Controls({ workflow }: { workflow: Workflow }) {
  return (
    <div className="controls">
      <div className="d-flex bd-highlight">
        <Title workflow={workflow} />
      </div>
    </div>
  );
}
